/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiEvent,
    ApiEventFromJSON,
    ApiEventToJSON,
} from '../models';

/**
 * 
 */
export class SanctionsApi extends runtime.BaseAPI {

    /**
     * triggers manual organisation check
     */
    async checkOrganisationRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiEvent>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/check`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiEventFromJSON(jsonValue));
    }

    /**
     * triggers manual organisation check
     */
    async checkOrganisation(initOverrides?: RequestInit): Promise<ApiEvent> {
        const response = await this.checkOrganisationRaw(initOverrides);
        return await response.value();
    }

}
